import React from 'react';

export default function Services() {
  const services = [
    {
      title: 'Kitchen Remodeling',
      description:
        'Complete kitchen renovations including cabinets, countertops, and modern upgrades designed to enhance both style and functionality.',
      image:
        'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/10d465263a8f09760d4e2455b3967e15.png',
    },
    {
      title: 'Bathroom Remodels',
      description:
        'From classic tile work to elegant onyx installations, we handle every aspect of your bathroom transformation with expert craftsmanship.',
      image:
        'https://public.readdy.ai/ai/img_res/97e4b691af47d30fa27aed658da16380.jpg',
    },
    {
      title: 'Walk-In Tubs',
      description:
        'Safe, comfortable walk-in tub installations designed for accessibility and luxury.',
      image:
        'https://static.readdy.ai/image/ec7d44241e5d5731ab0de78142a46920/43e94e3ab266063b14c7c6b068374a34.png',
    },
  ];

  return (
    <section id="services" className="bg-white py-16 sm:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 sm:mb-20">
          <div className="flex items-center justify-center gap-2 mb-4">
            <div className="w-2 h-2 rounded-full bg-[#0B1F3A]"></div>
            <span
              className="text-[#0B1F3A] text-sm font-semibold tracking-widest uppercase"
              style={{ fontFamily: 'Open Sans, sans-serif' }}
            >
              Our Services
            </span>
          </div>
          <h2
            className="text-[#0B1F3A] text-3xl sm:text-4xl lg:text-5xl font-bold"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            Craftsmanship in Every Detail
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer group"
            >
              <div className="w-full h-56 sm:h-72 md:h-80 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6 sm:p-8">
                <h3
                  className="text-[#0B1F3A] text-xl sm:text-2xl font-semibold mb-3 sm:mb-4"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  {service.title}
                </h3>
                <div className="w-10 h-1 bg-[#2D6CDF] mb-4 sm:mb-6"></div>
                <p
                  className="text-[#1A1A1A] text-sm sm:text-base leading-relaxed"
                  style={{ fontFamily: 'Open Sans, sans-serif', lineHeight: '1.7' }}
                >
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
